export { default } from "./Resources";
